<kendo-dialog (close)="accion('cerrar')" [minWidth]="250" [width]="700">
    <div class="row" style="margin-top: 50px;">
        <div class="col-md-12">
            <div class="d-flex justify-content-center">
                <p class="subtitle">{{ titulo | uppercase }}</p>
            </div>
        </div>
    </div>
    <p style="margin: 30px; text-align: center;" [innerHTML]="Mensaje.mensaje"></p>
    <div class="row">
        <div class="col-md-12">
            <div class="d-flex justify-content-center">
                <button kendoButton (click)="accion('aceptar')" class="k-button  esFlex">ACEPTAR</button>
                <span *ngIf="btnCancelar">&nbsp;&nbsp;</span><button  kendoButton *ngIf="btnCancelar" (click)="accion('cancelar')" class="k-button  esFlex">CANCELAR</button> <!---->
                <span *ngIf="btnDescargar">&nbsp;&nbsp;</span><button  kendoButton *ngIf="btnDescargar" (click)="accion('descargar')" class="k-button  esFlex">DESCARGAR</button> <!---->

            </div>
        </div>
    </div>
    
</kendo-dialog>
